import React from "react";

function Profile() {
  // loadData = () => {
  //   const { data } = this.state;
  //   const endpoint = `https://randomuser.me/api/?nat=us&results=${per}&page=${page}`;
  //   fetch(endpoint)
  //     .then((response) => response.json())
  //     .then((json) => {
  //       this.setState({
  //         data: [...data, ...json.results],
  //       });
  //     });
  // };

  return (
    <>
      <div id="kt_content_container" className="container-xxl">
        <h1>User Profile Page </h1>
        <div className="card-body pt-9 pb-0">
          {/*begin::Details*/}
          <div className="d-flex flex-wrap flex-sm-nowrap">
            {/*begin: Pic*/}
            <div className="me-7 mb-4">
              <div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                <img src="assets/media/avatars/300-1.jpg" alt="image" />
                <div className="position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px" />
              </div>
            </div>
            {/*end::Pic*/}
            {/*begin::Info*/}
            <div className="flex-grow-1">
              {/*begin::Title*/}
              <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                {/*begin::User*/}
                <div className="d-flex flex-column">
                  {/*begin::Name*/}
                  <div className="d-flex align-items-center mb-2">
                    <a
                      href="#"
                      className="text-gray-900 text-hover-primary fs-2 fw-bolder me-1"
                    >
                      Max Smith
                    </a>
                    <a href="#">
                      {/*begin::Svg Icon | path: icons/duotune/general/gen026.svg*/}
                      <span className="svg-icon svg-icon-1 svg-icon-primary">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M10.0813 3.7242C10.8849 2.16438 13.1151 2.16438 13.9187 3.7242V3.7242C14.4016 4.66147 15.4909 5.1127 16.4951 4.79139V4.79139C18.1663 4.25668 19.7433 5.83365 19.2086 7.50485V7.50485C18.8873 8.50905 19.3385 9.59842 20.2758 10.0813V10.0813C21.8356 10.8849 21.8356 13.1151 20.2758 13.9187V13.9187C19.3385 14.4016 18.8873 15.491 19.2086 16.4951V16.4951C19.7433 18.1663 18.1663 19.7433 16.4951 19.2086V19.2086C15.491 18.8873 14.4016 19.3385 13.9187 20.2758V20.2758C13.1151 21.8356 10.8849 21.8356 10.0813 20.2758V20.2758C9.59842 19.3385 8.50905 18.8873 7.50485 19.2086V19.2086C5.83365 19.7433 4.25668 18.1663 4.79139 16.4951V16.4951C5.1127 15.491 4.66147 14.4016 3.7242 13.9187V13.9187C2.16438 13.1151 2.16438 10.8849 3.7242 10.0813V10.0813C4.66147 9.59842 5.1127 8.50905 4.79139 7.50485V7.50485C4.25668 5.83365 5.83365 4.25668 7.50485 4.79139V4.79139C8.50905 5.1127 9.59842 4.66147 10.0813 3.7242V3.7242Z"
                            fill="#00A3FF"
                          />
                          <path
                            className="permanent"
                            d="M14.8563 9.1903C15.0606 8.94984 15.3771 8.9385 15.6175 9.14289C15.858 9.34728 15.8229 9.66433 15.6185 9.9048L11.863 14.6558C11.6554 14.9001 11.2876 14.9258 11.048 14.7128L8.47656 12.4271C8.24068 12.2174 8.21944 11.8563 8.42911 11.6204C8.63877 11.3845 8.99996 11.3633 9.23583 11.5729L11.3706 13.4705L14.8563 9.1903Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                      {/*end::Svg Icon*/}
                    </a>
                  </div>
                  {/*end::Name*/}
                  {/*begin::Info*/}
                  <div className="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                    <a
                      href="#"
                      className="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
                    >
                      {/*begin::Svg Icon | path: icons/duotune/communication/com006.svg*/}
                    </a>
                    <a
                      href="#"
                      className="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
                    >
                      {/*begin::Svg Icon | path: icons/duotune/general/gen018.svg*/}
                      <span className="svg-icon svg-icon-4 me-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            opacity="0.3"
                            d="M18.0624 15.3453L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3453C4.56242 13.6453 3.76242 11.4453 4.06242 8.94534C4.56242 5.34534 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24534 19.9624 9.94534C20.0624 12.0453 19.2624 13.9453 18.0624 15.3453Z"
                            fill="black"
                          />
                          <path
                            d="M12.0624 13.0453C13.7193 13.0453 15.0624 11.7022 15.0624 10.0453C15.0624 8.38849 13.7193 7.04535 12.0624 7.04535C10.4056 7.04535 9.06241 8.38849 9.06241 10.0453C9.06241 11.7022 10.4056 13.0453 12.0624 13.0453Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                      {/*end::Svg Icon*/}SF, Bay Area
                    </a>
                    <a
                      href="#"
                      className="d-flex align-items-center text-gray-400 text-hover-primary mb-2"
                    >
                      {/*begin::Svg Icon | path: icons/duotune/communication/com011.svg*/}
                      <span className="svg-icon svg-icon-4 me-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            opacity="0.3"
                            d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z"
                            fill="black"
                          />
                          <path
                            d="M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                      {/*end::Svg Icon*/}max@kt.com
                    </a>
                  </div>
                  {/*end::Info*/}
                </div>
                {/*end::User*/}
                {/*begin::Actions*/}
                <div className="d-flex my-4">
                  <a
                    href="#"
                    className="btn btn-sm btn-light me-2"
                    id="kt_user_follow_button"
                  >
                    {/*begin::Svg Icon | path: icons/duotune/arrows/arr012.svg*/}
                    {/* <span className="svg-icon svg-icon-3 d-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          opacity="0.3"
                          d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z"
                          fill="black"
                        />
                        <path
                          d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z"
                          fill="black"
                        />
                      </svg>
                    </span> */}
                    {/*end::Svg Icon*/}
                    {/*begin::Indicator*/}
                    {/* <span className="indicator-label">Follow</span> */}
                    {/* <span className="indicator-progress">
                      Please wait...
                      <span className="spinner-border spinner-border-sm align-middle ms-2" />
                    </span> */}
                    {/*end::Indicator*/}
                  </a>
                  {/* <a
                    href="#"
                    className="btn btn-sm btn-primary me-2"
                    data-bs-toggle="modal"
                    data-bs-target="#kt_modal_offer_a_deal"
                  >
                    Hire Me
                  </a> */}
                  {/*begin::Menu*/}
                  <div className="me-0">
                    <button
                      className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
                      data-kt-menu-trigger="click"
                      data-kt-menu-placement="bottom-end"
                    >
                      <i className="bi bi-three-dots fs-3" />
                    </button>
                    {/*begin::Menu 3*/}
                    <div
                      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px py-3"
                      data-kt-menu="true"
                    >
                      {/*begin::Heading*/}
                      <div className="menu-item px-3">
                        <div className="menu-content text-muted pb-2 px-3 fs-7 text-uppercase">
                          Profile
                        </div>
                      </div>
                      {/*end::Heading*/}
                      {/*begin::Menu item*/}
                      <div className="menu-item px-3">
                        <a href="#" className="menu-link px-3">
                          Edit Profile
                        </a>
                      </div>
                      {/*end::Menu item*/}
                      {/*begin::Menu item*/}
                      {/* <div className="menu-item px-3">
                        <a href="#" className="menu-link flex-stack px-3">
                          Create Payment
                          <i
                            className="fas fa-exclamation-circle ms-2 fs-7"
                            data-bs-toggle="tooltip"
                            title
                            data-bs-original-title="Specify a target name for future usage and reference"
                            aria-label="Specify a target name for future usage and reference"
                          />
                        </a>
                      </div> */}
                      {/*end::Menu item*/}
                      {/*begin::Menu item*/}
                      {/* <div className="menu-item px-3">
                        <a href="#" className="menu-link px-3">
                          Generate Bill
                        </a>
                      </div> */}
                      {/*end::Menu item*/}
                      {/*begin::Menu item*/}

                      {/*end::Menu item*/}
                      {/*begin::Menu item*/}
                      {/* <div className="menu-item px-3 my-1">
                        <a href="#" className="menu-link px-3">
                          Settings
                        </a>
                      </div> */}
                      {/*end::Menu item*/}
                    </div>
                    {/*end::Menu 3*/}
                  </div>
                  {/*end::Menu*/}
                </div>
                {/*end::Actions*/}
              </div>
              {/*end::Title*/}
              {/*begin::Stats*/}
              <div className="d-flex flex-wrap flex-stack">
                {/*begin::Wrapper*/}
                <div className="d-flex flex-column flex-grow-1 pe-8">
                  {/*begin::Stats*/}
                  <div className="d-flex flex-wrap">
                    {/*begin::Stat*/}

                    {/*end::Stat*/}
                    {/*begin::Stat*/}

                    {/*end::Stat*/}
                    {/*begin::Stat*/}

                    {/*end::Stat*/}
                  </div>
                  {/*end::Stats*/}
                </div>
                {/*end::Wrapper*/}
                {/*begin::Progress*/}
                {/* <div className="d-flex align-items-center w-200px w-sm-300px flex-column mt-3">
                  <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                    <span className="fw-bold fs-6 text-gray-400">
                      Profile Compleation
                    </span>
                    <span className="fw-bolder fs-6">50%</span>
                  </div>
                  <div className="h-5px mx-3 w-100 bg-light mb-3">
                    <div
                      className="bg-success rounded h-5px"
                      role="progressbar"
                      style={{ width: "50%" }}
                      aria-valuenow={50}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    />
                  </div>
                </div> */}
                {/*end::Progress*/}
              </div>
              {/*end::Stats*/}
            </div>
            {/*end::Info*/}
          </div>
          {/*end::Details*/}
          {/*begin::Navs*/}
          <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder">
            {/*begin::Nav item*/}
            {/* <li className="nav-item mt-2">
              <a
                className="nav-link text-active-primary ms-0 me-10 py-5"
                href="../../demo1/dist/pages/user-profile/overview.html"
              >
                Overview
              </a>
            </li> */}
            {/*end::Nav item*/}
            {/*begin::Nav item*/}
            {/* <li className="nav-item mt-2">
              <a
                className="nav-link text-active-primary ms-0 me-10 py-5 active"
                href="../../demo1/dist/pages/user-profile/projects.html"
              >
                Projects
              </a>
            </li> */}
            {/*end::Nav item*/}
            {/*begin::Nav item*/}
            {/* <li className="nav-item mt-2">
              <a
                className="nav-link text-active-primary ms-0 me-10 py-5"
                href="../../demo1/dist/pages/user-profile/campaigns.html"
              >
                Campaigns
              </a>
            </li> */}
            {/*end::Nav item*/}
            {/*begin::Nav item*/}
            {/* <li className="nav-item mt-2">
              <a
                className="nav-link text-active-primary ms-0 me-10 py-5"
                href="../../demo1/dist/pages/user-profile/documents.html"
              >
                Documents
              </a>
            </li> */}
            {/*end::Nav item*/}
            {/*begin::Nav item*/}
            {/* <li className="nav-item mt-2">
              <a
                className="nav-link text-active-primary ms-0 me-10 py-5"
                href="../../demo1/dist/pages/user-profile/followers.html"
              >
                Followers
              </a>
            </li> */}
            {/*end::Nav item*/}
            {/*begin::Nav item*/}
            {/* <li className="nav-item mt-2">
              <a
                className="nav-link text-active-primary ms-0 me-10 py-5"
                href="../../demo1/dist/pages/user-profile/activity.html"
              >
                Activity
              </a>
            </li> */}
            {/*end::Nav item*/}
          </ul>
          {/*begin::Navs*/}
        </div>
      </div>
    </>
  );
}

export default Profile;
